module.exports = __webpack_public_path__ + "img/message_archive.e9f8dd95.svg";